interface LogEntry {
    timestamp: string
    level: string
    message: string
}

const MAX_ENTRIES = 500
const entries: LogEntry[] = []

export function addLogEntry(level: string, message: string) {
    entries.push({
        timestamp: new Date().toISOString(),
        level,
        message,
    })
    if (entries.length > MAX_ENTRIES) {
        entries.splice(0, entries.length - MAX_ENTRIES)
    }
}

export function getLogEntries(): string {
    return entries.map(e => `${e.timestamp} [${e.level}] ${e.message}`).join('\n')
}

export function clearLogEntries() {
    entries.length = 0
}
